import { ClientPortalGlobalSearchResultModel, ClientPortalGlobalSearchResultTypes } from "services/api/cplapi/CPLAPI";

export function buildSearchResultRedirectRoute(searchResult: ClientPortalGlobalSearchResultModel): string {
  switch (searchResult.type) {
    case ClientPortalGlobalSearchResultTypes.Case:
      return `/Case/${searchResult.recordID}/Details`;
    case ClientPortalGlobalSearchResultTypes.Meeting:
      return `/Meetings`;
    case ClientPortalGlobalSearchResultTypes.ProposedWorks:
      return `/majorwork/${searchResult.recordID}`;
    case ClientPortalGlobalSearchResultTypes.Job:
      return `/Job/${searchResult.recordID}`;
    case ClientPortalGlobalSearchResultTypes.Transaction:
      return `/ClientTransactions/${searchResult.recordID}`;
    default:
      return "SearchResults/";
  }
}
